import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ForexDataSourceHistoryContainerModel} from '../../../../../../models/aggregates/erp/forex-data-source-history';

@Injectable({providedIn: 'root'})
export class ForexDataSourceHistoryService extends BaseApiTemplateService<ForexDataSourceHistoryContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'forex-data-source-histories/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'forex-data-source-histories/backoffice-ep';
    this.httpClient = http;
  }
}